<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5">
      <!-- Card stats -->

    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-body">
              <GraphicsManager />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphicsManager from './Charts/GraphicsManager.vue'

export default {
  name: "Graphics",
  components: {
    GraphicsManager
  },
  data() {
    return {
    }
  },
};
</script>

<style></style>
